/**
 * 首页展示用静态文案与占位数据
 */
export const PRODUCT_TITLE = "宾利山茱萸100%原汁发酵阴阳双补红酒";

export const PRODUCT_DESC =
  "山茱萸为药食同源，阴阳双补，其独有马钱苷与莫诺苷等活性成分，是温和滋补身体的佳品。";

export const PRODUCT_PRICE = "$236";

export const SUPERIOR_ADDRESS_MOCK = "0x30A91562a9183bdC758b7f155D1AC8A91B5CD2e9";

/** 首页奖金池等级定义（人数、金额由链上接口填充） */
export const PRIZE_POOL_LEVELS = [
  { id: "v1", label: "V1池" },
  { id: "v2", label: "V2池" },
  { id: "v3", label: "V3池" },
  { id: "v4", label: "V4池" },
  { id: "v5", label: "V5池" },
];

/** 兼容旧引用：仅结构与占位，不参与首页真实展示逻辑 */
export const PRIZE_POOLS = PRIZE_POOL_LEVELS.map((row) => ({
  ...row,
  people: 0,
  amount: "—",
}));

/** 个人业绩占位（连接钱包后由链上数据替换） */
export function createPersonalStatsPlaceholder() {
  return [
    { value: "—", label: "直推数量" },
    { value: "—", label: "总业绩" },
    { value: "—", label: "小区业绩" },
    { value: "—", label: "推荐奖励" },
    { value: "—", label: "个人级别" },
    { value: "—", label: "级别奖励" },
    { value: "—", label: "节点" },
    { value: "—", label: "节点奖励" },
    { value: "—", label: "奖励未提取" },
  ];
}
